import { render, staticRenderFns } from "./FinalBatchReviewPage.vue?vue&type=template&id=44e6494c&"
import script from "./FinalBatchReviewPage.vue?vue&type=script&lang=ts&"
export * from "./FinalBatchReviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./FinalBatchReviewPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports